import React from 'react';

// ANTD
import { Col, Row } from 'antd';

// REDUX
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store';

//	COMPONENTS
import { v4 as uuidV4 } from 'uuid';

//	COMPONENTS COMMON
import Section from 'components/Common/Section';

// UTILS
import { isFilledValue } from 'utils/stringFunctions';
import { patternFormat } from 'utils/genericFunctions';
import { formatDateISOToFullUTC } from 'utils/dateFunctions';

const ResultadoDBCIN: React.FC = () => {
	const { consultarCinPPT } = useSelector(
		(state: ApplicationState) => state.api.iirgd.integrador,
	);

	return (
		<Row>
			<Col span={24}>
				<Section title="Resultado da Consulta">
					<Section key={uuidV4()} style={{ marginTop: '5px' }}>
						<Row>
							<Col span={24}>
								<p>
									<strong>RG: </strong>
									{isFilledValue(
										patternFormat(
											consultarCinPPT.data?.registroNumero?.concat(
												consultarCinPPT.data?.registroDigito,
											),
											`##.###.###-#`,
										),
									)}
								</p>
							</Col>
						</Row>
						<Row>
							<Col span={24}>
								<p>
									<strong>CPF: </strong>
									{isFilledValue(
										patternFormat(
											consultarCinPPT.data?.usuarioInclusaoCpf,
											`###.###.###-##`,
										),
									)}
								</p>
							</Col>
						</Row>
						<br />
						<Row>
							<Col span={24}>
								<p>
									<strong>Dados RFB: </strong>
								</p>
							</Col>
						</Row>
						<br />
						<Row>
							<Col span={24}>
								<p>
									<strong>Código Hash: </strong>
									{isFilledValue(consultarCinPPT.data?.codigoHashRfb)}
								</p>
							</Col>
						</Row>
						<Row>
							<Col span={24}>
								<p>
									<strong>Protocolo: </strong>
									{isFilledValue(consultarCinPPT.data?.protocoloRfb)}
								</p>
							</Col>
						</Row>
						<Row>
							<Col span={24}>
								<p>
									<strong>Data Protocolo: </strong>
									{consultarCinPPT.data &&
									consultarCinPPT.data?.dataProtocoloRfb
										? formatDateISOToFullUTC(
												new Date(consultarCinPPT.data?.dataProtocoloRfb),
										  )
										: isFilledValue(consultarCinPPT.data?.dataProtocoloRfb)}
								</p>
							</Col>
						</Row>
						<Row>
							<Col span={24}>
								<p>
									<strong>Indicador Consistência Biográfica: </strong>
									{isFilledValue(
										consultarCinPPT.data?.indicadorConsistenciaBiografica,
									)}
								</p>
							</Col>
						</Row>
						<Row>
							<Col span={24}>
								<p>
									<strong>Indicador Consistência Biométrica: </strong>
									{isFilledValue(
										consultarCinPPT.data?.indicadorConsistenciaBiometrica,
									)}
								</p>
							</Col>
						</Row>
						<Row>
							<Col span={24}>
								<p>
									<strong>Situação SERPRO: </strong>
									{isFilledValue(consultarCinPPT.data?.situacaoSerpro)}
								</p>
							</Col>
						</Row>
						<br />
						<Row>
							<Col span={24}>
								<p>
									<strong>Dados RFB: </strong>
								</p>
							</Col>
						</Row>
						<br />
						<Row>
							<Col span={24}>
								<p>
									<strong>Posto Emissor: </strong>
									{isFilledValue(consultarCinPPT.data?.postoEmissor)}
								</p>
							</Col>
						</Row>
						<Row>
							<Col span={24}>
								<p>
									<strong>Tipográfico: </strong>
									{isFilledValue(consultarCinPPT.data?.tipoGrafico)}
								</p>
							</Col>
						</Row>
						<Row>
							<Col span={24}>
								<p>
									<strong>Protocolo da Imagem: </strong>
									{isFilledValue(consultarCinPPT.data?.prtValidImagem)}
								</p>
							</Col>
						</Row>
						<Row>
							<Col span={24}>
								<p>
									<strong>Imagem CIN: </strong>
									{isFilledValue(consultarCinPPT.data?.cinImagem)}
								</p>
							</Col>
						</Row>
						<Row>
							<Col span={24}>
								<p>
									<strong>QRCode CIN: </strong>
									{isFilledValue(consultarCinPPT.data?.cinQrCode)}
								</p>
							</Col>
						</Row>
						<Row>
							<Col span={24}>
								<p>
									<strong>Código MRZ Passaporte: </strong>
									{isFilledValue(consultarCinPPT.data?.codMrzPassaporte)}
								</p>
							</Col>
						</Row>
						<Row>
							<Col span={24}>
								<p>
									<strong>Data Emissão: </strong>
									{consultarCinPPT.data && consultarCinPPT.data?.dataEmissao
										? formatDateISOToFullUTC(
												new Date(consultarCinPPT.data?.dataEmissao),
										  )
										: isFilledValue(consultarCinPPT.data?.dataEmissao)}
								</p>
							</Col>
						</Row>
						<Row>
							<Col span={24}>
								<p>
									<strong>Situação: </strong>
									{`${isFilledValue(
										consultarCinPPT.data?.situacao,
									)} - ${isFilledValue(
										consultarCinPPT.data?.situacaoDescricao,
									)}`}
									{/* {isFilledValue(
										`${consultarCinPPT.data?.situacao} - ${consultarCinPPT.data?.situacaoDescricao}`,
									)} */}
								</p>
							</Col>
						</Row>
						<Row>
							<Col span={24}>
								<p>
									<strong>Observações: </strong>
									{isFilledValue(consultarCinPPT.data?.observacao)}
								</p>
							</Col>
						</Row>
						<br />
						<Row>
							<Col span={24}>
								<p>
									<strong>Atualizações: </strong>
								</p>
							</Col>
						</Row>
						<br />
						<Row>
							<Col span={24}>
								<p>
									<strong>Inclusão: </strong>
								</p>
							</Col>
						</Row>
						<Row>
							<Col span={24}>
								<p>
									<strong>Usuário: </strong>
									{isFilledValue(consultarCinPPT.data?.usuarioInclusao)}
								</p>
							</Col>
						</Row>
						<Row>
							<Col span={24}>
								<p>
									<strong>CPF: </strong>
									{isFilledValue(
										patternFormat(
											consultarCinPPT.data?.usuarioInclusaoCpf,
											`###.###.###-##`,
										),
									)}
								</p>
							</Col>
						</Row>
						<Row>
							<Col span={24}>
								<p>
									<strong>Data: </strong>
									{consultarCinPPT.data && consultarCinPPT.data?.dataInclusao
										? formatDateISOToFullUTC(
												new Date(consultarCinPPT.data?.dataInclusao),
										  )
										: isFilledValue(consultarCinPPT.data?.dataInclusao)}
								</p>
							</Col>
						</Row>
						<br />
						<Row>
							<Col span={24}>
								<p>
									<strong>Alteração: </strong>
								</p>
							</Col>
						</Row>
						<Row>
							<Col span={24}>
								<p>
									<strong>Usuário: </strong>
									{isFilledValue(consultarCinPPT.data?.usuarioAlteracao)}
								</p>
							</Col>
						</Row>
						<Row>
							<Col span={24}>
								<p>
									<strong>CPF: </strong>
									{isFilledValue(
										patternFormat(
											consultarCinPPT.data?.usuarioAlteracaoCpf,
											`###.###.###-##`,
										),
									)}
								</p>
							</Col>
						</Row>
						<Row>
							<Col span={24}>
								<p>
									<strong>Data: </strong>
									{consultarCinPPT.data && consultarCinPPT.data?.dataAlteracao
										? formatDateISOToFullUTC(
												new Date(consultarCinPPT.data?.dataAlteracao),
										  )
										: isFilledValue(consultarCinPPT.data?.dataAlteracao)}
								</p>
							</Col>
						</Row>
					</Section>
				</Section>
			</Col>
		</Row>
	);
};

export default ResultadoDBCIN;
